import http from "../http-common";
import axios from "axios";

class crmService {

   
    getContacts = (params = {}) => http.get('/crm/contacts', { params })

    addContact = (data) => http.post(`/crm/contacts`, data);

    updateContact = (contact_id, data) => http.put(`/crm/contacts/${contact_id}`, data);

    importContacts = (data) => axios.post(process.env.VUE_APP_API_URL+'/api/crm/contacts/import', data,
        { withCredentials: true });
    
    getContactImportHistory = () => http.get(`/crm/contacts/import`);

    rollBackContactImportRecord = (import_id) => http.delete(`/crm/contacts/import/${import_id}`);

    fetchEmailsForImportedContacts = (import_id) => http.get(`/crm/contacts/import/fetchemails/${import_id}`);


}
export default new crmService();